import { Component, render } from 'preact';


export default class Common extends Component {
  needs_update = {val:true};
  input_old = {};

  input_changed = (input_str) => {
    //let input_new = this.props.input_new[input_str];

    let input = this.props.input;
    //if (input_new == undefined) {
    if (input == undefined) {
      return false;
    }
    //let input_old = this.input[input_str];

    if (this.input_old[input_str] != input[input_str]) {
      this.input_old[input_str] = input[input_str];
      return true;
    }
    else{
      return false;
    }
  }

}

const round_place = (num, place) => {
  return (Math.round((num + Number.EPSILON) * place) / place);
};

export {round_place};